import React from 'react';
import styled from '@emotion/styled';

import { getCurrencyString } from '../PriceString';

interface NewsletterCreditOfferProps {
    className?: string;
    currency?: string;
    amount?: number;
}

export const NewsletterCreditOffer: React.FC<NewsletterCreditOfferProps> = ({
    className,
    currency,
    amount,
}) => {
    return (
        <svg
            viewBox="0 0 141 105"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <ellipse cx="108.5" cy="37" rx="17.5" ry="17" fill="#F1F3F4" />
            <circle cx="27" cy="71" r="22" fill="#FFEFC3" />
            <circle cx="72.5" cy="71.5" r="29.5" fill="#CEEAD6" />
            <circle cx="110.489" cy="62.3858" r="17.8106" fill="black" fillOpacity="0.03" />
            <circle cx="52.9038" cy="27.5327" r="21.1243" fill="#D2E4FC" />
            <circle cx="6.51307" cy="43.2723" r="6.21302" fill="#F8F9FA" />
            <circle cx="113.146" cy="60.729" r="16.1538" fill="#FBD1CF" />
            <circle cx="37.5783" cy="51.1432" r="16.568" fill="#F1F3F4" />
            <circle cx="85.6254" cy="23.8051" r="15.7396" fill="#F1F3F4" />

            <g clipPath="url(#clip0_419_1243)">
                <path
                    d="M109 50C109 53.0738 105.234 55.5385 104.458 58.4462C103.683 61.3538 105.677 65.4523 104.182 68C102.686 70.5477 98.1446 70.9077 96.04 73.04C93.9354 75.1723 93.6031 79.6862 91 81.1815C88.3969 82.6769 84.3538 80.6831 81.4462 81.4585C78.5385 82.2338 76.0738 86 73 86C69.9262 86 67.4615 82.2338 64.6923 81.4585C61.9231 80.6831 57.6862 82.6769 55.1385 81.1815C52.5908 79.6862 52.2308 75.1446 50.0985 73.04C47.9662 70.9354 43.4523 70.6031 41.9569 68C40.4615 65.3969 42.4554 61.3538 41.68 58.4462C40.9046 55.5385 37 53.0738 37 50C37 46.9262 40.7662 44.4615 41.5415 41.6923C42.3169 38.9231 40.3231 34.6862 41.8185 32.1385C43.3138 29.5908 47.8554 29.0923 49.96 26.96C52.0646 24.8277 52.3969 20.3138 55 18.8185C57.6031 17.3231 61.6462 19.3169 64.5538 18.5415C67.4615 17.7662 69.9262 14 73 14C76.0738 14 78.5385 17.7662 81.4462 18.5415C84.3538 19.3169 88.4523 17.3231 91 18.8185C93.5477 20.3138 93.9077 24.8554 96.04 26.96C98.1723 29.0646 102.686 29.3969 104.182 32C105.677 34.6031 103.683 38.6462 104.458 41.5538C105.234 44.4615 109 46.9262 109 50Z"
                    fill="url(#paint0_linear_419_1243)"
                />
                <path
                    d="M73 77.3461C88.1028 77.3461 100.346 65.1028 100.346 50C100.346 34.8971 88.1028 22.6538 73 22.6538C57.8971 22.6538 45.6538 34.8971 45.6538 50C45.6538 65.1028 57.8971 77.3461 73 77.3461Z"
                    fill="white"
                    fillOpacity="0.35"
                />
            </g>

            <defs>
                <linearGradient
                    id="paint0_linear_419_1243"
                    x1="73"
                    y1="14"
                    x2="73"
                    y2="86"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF5A5A" />
                    <stop offset="1" stopColor="#FF0000" />
                </linearGradient>
                <clipPath id="clip0_419_1243">
                    <rect width="72" height="72" fill="white" transform="translate(37 14)" />
                </clipPath>
            </defs>

            {amount && (
                <text x="61" y="48" fill="white" fontSize="20" fontWeight="bold">
                    {getCurrencyString(amount, currency)}
                </text>
            )}
        </svg>
    );
};

export default NewsletterCreditOffer;
